
export const NEW_CENTRO_CUSTO_CADASTRO = 'NEW_CENTRO_CUSTO_CADASTRO'
export const NEW_CENTRO_CUSTO_CADASTRO_SUCCESS = 'NEW_CENTRO_CUSTO_CADASTRO_SUCCESS'

export const CREATE_CENTRO_CUSTO_CADASTRO = 'CREATE_CENTRO_CUSTO_CADASTRO'
export const CREATE_CENTRO_CUSTO_CADASTRO_PENDING = 'CREATE_CENTRO_CUSTO_CADASTRO_PENDING'
export const CREATE_CENTRO_CUSTO_CADASTRO_SUCCESS = 'CREATE_CENTRO_CUSTO_CADASTRO_SUCCESS'
export const CREATE_CENTRO_CUSTO_CADASTRO_FAILURE = 'CREATE_CENTRO_CUSTO_CADASTRO_FAILURE'

export const CANCEL_CENTRO_CUSTO_CADASTRO_RAPIDO = 'CANCEL_CENTRO_CUSTO_CADASTRO_RAPIDO'
export const CANCEL_CENTRO_CUSTO_CADASTRO_RAPIDO_SUCCESS = 'CANCEL_CENTRO_CUSTO_CADASTRO_RAPIDO_SUCCESS'

export const TABLE_CENTRO_CUSTO_CADASTRO = 'TABLE_CENTRO_CUSTO_CADASTRO'
export const TABLE_CENTRO_CUSTO_CADASTRO_PENDING = 'TABLE_CENTRO_CUSTO_CADASTRO_PENDING'
export const TABLE_CENTRO_CUSTO_CADASTRO_SUCCESS = 'TABLE_CENTRO_CUSTO_CADASTRO_SUCCESS'
export const TABLE_CENTRO_CUSTO_CADASTRO_FAILURE = 'TABLE_CENTRO_CUSTO_CADASTRO_FAILURE'

export const LIST_CENTRO_CUSTO_CADASTRO = 'LIST_CENTRO_CUSTO_CADASTRO'
export const LIST_CENTRO_CUSTO_CADASTRO_PENDING = 'LIST_CENTRO_CUSTO_CADASTRO_PENDING'
export const LIST_CENTRO_CUSTO_CADASTRO_SUCCESS = 'LIST_CENTRO_CUSTO_CADASTRO_SUCCESS'
export const LIST_CENTRO_CUSTO_CADASTRO_FAILURE = 'LIST_CENTRO_CUSTO_CADASTRO_FAILURE'

export const FIND_CENTRO_CUSTO_CADASTRO = 'FIND_CENTRO_CUSTO_CADASTRO'
export const FIND_CENTRO_CUSTO_CADASTRO_PENDING = 'FIND_CENTRO_CUSTO_CADASTRO_PENDING'
export const FIND_CENTRO_CUSTO_CADASTRO_SUCCESS = 'FIND_CENTRO_CUSTO_CADASTRO_SUCCESS'
export const FIND_CENTRO_CUSTO_CADASTRO_FAILURE = 'FIND_CENTRO_CUSTO_CADASTRO_FAILURE'

export const DELETE_CENTRO_CUSTO_CADASTRO = 'DELETE_CENTRO_CUSTO_CADASTRO'
export const DELETE_CENTRO_CUSTO_CADASTRO_PENDING = 'DELETE_CENTRO_CUSTO_CADASTRO_PENDING'
export const DELETE_CENTRO_CUSTO_CADASTRO_SUCCESS = 'DELETE_CENTRO_CUSTO_CADASTRO_SUCCESS'
export const DELETE_CENTRO_CUSTO_CADASTRO_FAILURE = 'DELETE_CENTRO_CUSTO_CADASTRO_FAILURE'
